import axios from "axios";

import URLS from "../../util/urls.js";

const state = {
  portal: {
    nome: '',
    imoveisPublicados: [],
    ultimaAtualizacao: '',
    ultimoEnvio: '',
    urlIntegracao: '',
  },

  imoveisDisponiveis: [],
};

const mutations = {
  atualizarPortal(state, payload) {
    state.portal = payload.item;
  },

  atualizarImoveisDisponiveis(state, payload) {
    state.imoveisDisponiveis.push(...payload.lista);
  },

  limparImoveisDisponiveis(state) {
    state.imoveisDisponiveis = [];
  },
  limparImoveisPublicados(state) {
    state.portal.imoveisPublicados = [];
  },

  adicionarAosImoveisPublicados(state, payload) {
    state.portal.imoveisPublicados.push(...payload);
  },

  removerDosImoveisPublicados(state, payload) {
    const idsImoveisASeremRemovidos = payload.map(imovel => imovel.id);

    const imoveisPublicadosAtualizados = state.portal.imoveisPublicados
      .filter(imovel => !idsImoveisASeremRemovidos.includes(imovel.id));

    state.portal.imoveisPublicados = imoveisPublicadosAtualizados;
  },
};

const actions = {
  async recuperarPortal(context, payload) {
    try {
      const response = await axios.post(URLS.PORTAIS_RECUPERAR, payload);

      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarPortal', response.data);
          return response.data;

        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if (authResponse.status === 'SUCESSO') {
                return context.dispatch('recuperarPortal', payload);
              }
            })
            .catch(error => {
              throw error;
            });

        default:
          return response.data;
      }
    } catch (error) {
      throw error;
    }
  },
  
  async listarImoveis(context, payload) {
    try {
      const response = await axios.post(URLS.IMOVEIS_LISTAR, payload);

      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarImoveisDisponiveis', response.data);
          return response.data;

        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if (authResponse.status === 'SUCESSO') {
                return context.dispatch('listarImoveis', payload);
              }
            })
            .catch(error => {
              throw error;
            });
      }
    } catch (error) {
      throw error;
    }
  },

  gravarPortal(context, payload) {
    return axios.post(URLS.PORTAIS_GRAVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPortal', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarPortal', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  gerarRelatorioImoveisPortais(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch('gerarRelatorioImoveisPortais', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
};

export default {
  state,
  mutations,
  actions,
}